import React from 'react';

function About() {
  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <h2 className="text-3xl font-bold text-blue-900 mb-4">Sobre Mí</h2>
      <p className="text-lg text-gray-700 max-w-2xl mb-4">
        Soy Alexis Flores, Ingeniero de Sistemas Informáticos con especialización en bases de datos y redes. Me apasiona el desarrollo front-end y back-end, así como el análisis y diseño de sistemas informáticos a medida. Destaco por mi excelente desempeño en equipo, proactividad, autodidactismo, responsabilidad, creatividad y organización. Puedes contactarme en <a href="mailto:ajflores.290992@gmail.com" className="text-blue-600 hover:text-blue-800">ajflores.290992@gmail.com</a> o visitar mi perfil en <a href="https://www.linkedin.com/in/alexis-flores-483389107" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">LinkedIn</a>.
      </p>
      <h3 className="text-xl font-semibold text-blue-900 mt-6 mb-2">Educación</h3>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Ingeniero de Sistemas Informáticos - Universidad de El Salvador (2023)</li>
        <li>Bachiller General - Instituto Nacional de Sensuntepeque (2012)</li>
      </ul>
      <h3 className="text-xl font-semibold text-blue-900 mt-6 mb-2">Cursos</h3>
      <ul className="list-disc list-inside text-gray-700">
        <li>Taller de Mantenimiento y Reparación de Computadoras - INSAFORT (2017-2018)</li>
        <li>Diplomado en Desarrollo de Aplicaciones Móviles Android - UES Paracentral (2018-2019)</li>
        <li>Curso Básico de Inglés - UES Paracentral (2018-2019)</li>
        <li>Técnico en Redes de Datos - Capacítate para el Empleo (2022)</li>
        <li>Introducción a IoT - Cisco Networking Academy (2022)</li>
      </ul>
      <h3 className="text-xl font-semibold text-blue-900 mt-6 mb-2">Habilidades</h3>
<ul className="list-disc list-inside text-gray-700">
  <li>Mantenimiento y reparación de equipos informáticos</li>
  <li>Gestión de bases de datos (MySQL, SQL Server, PostgreSQL, Oracle, MongoDB)</li>
  <li>Desarrollo con C++, C#, Java, PHP, Laravel, React, Angular</li>
  <li>Desarrollo móvil con Android Studio</li>
  <li>Redes con Cisco Packet Tracer y servidores (Windows Server, Linux)</li>
  <li>Idioma Inglés (Nivel Básico)</li>
</ul>
    </div>
    
  );
  
}


export default About;
